import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Página puente: el admin abre /portal/impersonate?token=XXX en nueva
// tab. Aquí persistimos el token y redirigimos al dashboard. El layout
// del portal detecta `impersonatedBy` en el JWT y muestra un banner.
export function PortalImpersonate() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (!token) {
      navigate("/portal/login");
      return;
    }
    try {
      localStorage.setItem("userdata:portal", JSON.stringify({ token }));
    } catch {}
    navigate("/portal/dashboard", { replace: true });
  }, [location.search, navigate]);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#f8fafc" }}>
      <p style={{ color: "#64748b", fontSize: 14 }}>Abriendo portal del cliente...</p>
    </div>
  );
}
